import { reinit } from 'util/methods';
import { addAnswer } from '../components/answer';

export const addBlankAnswer = event => {
  addAnswer(event, null, null);
  reinit('application', 'tooltips');
};
